export default __webpack_public_path__ + "static/media/video-poster.9a279c49.jpg";